module.exports = __webpack_public_path__ + "static/media/buryTheCards_en.1bec98dc.svg";